/**
 * <Rial />
 * ---------
 * Inline glyph of the Central Bank of Oman's new Rial symbol. Rendered
 * as a small PNG (public/omr-rial.png) sized to match adjacent text.
 * Use anywhere the currency label previously read "OMR".
 *
 * Height defaults to 1em so it drops into any font-size context;
 * consumers can pass an explicit `className` for custom sizing/color.
 * Uses `img` (transparent PNG) so tinting is not possible — the asset
 * is drawn near-black to match `text-[#0F172A]`, which is our default
 * ink color across the app.
 */
import React from 'react';

// Marker asset — swap the file in `public/omr-rial.png` if the CBO
// releases an updated symbol. All call sites automatically pick up
// the change on next deploy.
export const Rial = ({ className = '', style = {} }) => (
  <img
    src="/omr-rial.png"
    alt="OMR"
    aria-label="Omani Rial"
    className={`inline-block align-[-0.15em] ${className}`}
    style={{
      height: '0.9em',
      width: 'auto',
      // Never let the browser stretch the transparent pixels — keep
      // the aspect ratio native.
      objectFit: 'contain',
      ...style,
    }}
    data-testid="rial-symbol"
  />
);

export default Rial;
